(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["igp-digital-services"] && !Shopify.designMode) return;
  try {
    
function bindDigitalQuote(){
 const form=document.getElementById('DigitalServicesQuote');if(!form||form.dataset.digitalBound)return;form.dataset.digitalBound='true';
 const phone=form.querySelector('[name="contact[phone]"]'),method=form.querySelector('[name="contact[Preferred contact]"]'),consult=form.querySelector('[name="contact[Consultation]"]');
 function update(){phone.required=method.value==='Phone'||consult?.value==='Please contact me to arrange';}
 method.addEventListener('change',update);consult?.addEventListener('change',update);update();
}
bindDigitalQuote();document.addEventListener('shopify:section:load',bindDigitalQuote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
